import { render, staticRenderFns } from "./CreateTemplateForm.vue?vue&type=template&id=3d20ae28&scoped=true"
import script from "./CreateTemplateForm.vue?vue&type=script&lang=js"
export * from "./CreateTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateForm.vue?vue&type=style&index=0&id=3d20ae28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20ae28",
  null
  
)

export default component.exports